import { applicationActions } from "../reducer";

import { ActiveModal } from '../../types';

export const addActiveModal = (
  activeModal: ActiveModal
) => applicationActions.addActiveModal(activeModal);
